<sl-step [step]="currentStep" class="mb-4">
    <sl-step-item label="Upload" i18n-label></sl-step-item>
    <sl-step-item label="Parsing" i18n-label></sl-step-item>
    <sl-step-item label="Match" i18n-label></sl-step-item>
    <sl-step-item label="Import" i18n-label></sl-step-item>
    <sl-step-item label="Done" i18n-label></sl-step-item>
</sl-step>

<div [ngSwitch]="current">
    <app-csv-upload *ngSwitchCase="'upload'" (onFileParse)="onFileParse($event)"></app-csv-upload>
    <div *ngSwitchCase="'parsing'">
        <sl-label size="large" i18n>Parsing data. Please wait...</sl-label>
    </div>
    <app-csv-matcher *ngSwitchCase="'match'" [fields]="fields" [parseResult]="currentImport"
        (onMatchComplete)="onMatchComplete()" (onMatchChange)="onMatchChange($event)"></app-csv-matcher>
    <app-csv-import-status *ngSwitchCase="'import'" [progress]="progressPercentage" [progressText]="progressText">
    </app-csv-import-status>

    <div *ngSwitchCase="'done'">
        <sl-alert *ngIf="importError != null" type="danger" open>
            <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
            <strong i18n>An error occured</strong><br>
            {{importError}}
        </sl-alert>
        <sl-alert *ngIf="importError == null" type="success" open>
            <sl-icon slot="icon" name="check2-circle"></sl-icon>
            <strong i18n>Success!</strong><br>
            <span i18n>Your data was sucessfully imported.</span>
        </sl-alert>
    </div>
</div>
